import { render, staticRenderFns } from "./ImportJson.vue?vue&type=template&id=60c43f6e&scoped=true&"
import script from "./ImportJson.vue?vue&type=script&lang=js&"
export * from "./ImportJson.vue?vue&type=script&lang=js&"
import style0 from "./ImportJson.vue?vue&type=style&index=0&id=60c43f6e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c43f6e",
  null
  
)

export default component.exports